import { render, staticRenderFns } from "./BuscadorOpcionesPagoFicha.vue?vue&type=template&id=5db53db4&"
import script from "./BuscadorOpcionesPagoFicha.vue?vue&type=script&lang=js&"
export * from "./BuscadorOpcionesPagoFicha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports